import { Tabs } from '~/shared/components/tabs/Tabs';
import { QueryParamTabs } from '~/shared/components/tabs/QueryParamTabs';
import { Inbox } from 'lucide-react';
import { PageLayout } from '~/shared/PageLayout';
import { AllLegacyReferrals } from './all-referrals/AllLegacyReferrals';
import { ReferralHeatMap } from './heat-map/ReferralHeatMap';
import { ReferralReport } from './report/ReferralReport';
import { ReferralNotificationPreview } from './notification-preview/ReferralNotificationPreview';
import { ReferralDetailsModal } from './ReferralDetailsModal';
import { SuspenseWrapper } from '~/shared/SuspenseWrapper';
import { useSearchParams } from 'react-router-dom';

const views = [
	{ label: 'All Referrals', value: 'all-referrals' },
	{ label: 'Coverage Map', value: 'coverage-map' },
	{ label: 'Notification Lookup', value: 'notification-lookup' },
	{ label: 'Reports', value: 'reports' }
];

export function LegacyReferralsPage() {
	const [searchParams, setSearchParams] = useSearchParams();
	const referralIdToView = searchParams.get('referralId');

	const closeReferralDetailsModal = () => {
		setSearchParams(prev => {
			prev.delete('referralId');
			return prev;
		});
	};

	return (
		<PageLayout pageHeader={{ title: 'My Referrals', description: 'Manage new and in-progress referral notifications', TitleIcon: Inbox }}>
			{referralIdToView && <ReferralDetailsModal referralId={referralIdToView} onClose={closeReferralDetailsModal} />}
			<QueryParamTabs defaultTab={views[0].value}>
				<Tabs.TabList>
					{views.map(view => (
						<Tabs.Tab id={view.value} key={view.value}>
							{view.label}
						</Tabs.Tab>
					))}
				</Tabs.TabList>
				<Tabs.TabPanel id="all-referrals" className="p-4">
					<AllLegacyReferrals />
				</Tabs.TabPanel>
				<Tabs.TabPanel id="coverage-map" className="p-4">
					<SuspenseWrapper fullScreen={false} name="referralCoverageMap">
						<ReferralHeatMap />
					</SuspenseWrapper>
				</Tabs.TabPanel>
				<Tabs.TabPanel id="notification-lookup" className="p-4">
					<ReferralNotificationPreview />
				</Tabs.TabPanel>
				<Tabs.TabPanel id="reports" className="p-4">
					<ReferralReport />
				</Tabs.TabPanel>
			</QueryParamTabs>
		</PageLayout>
	);
}
